const COVAL_EMAIL_DOMAIN = "coval.dev"

export function hasCovalAdminAccess(value: unknown): boolean {
  if (typeof value !== "string") {
    return false
  }

  const normalizedEmail = value.trim().toLowerCase()
  const emailParts = normalizedEmail.split("@")
  return (
    emailParts.length === 2 &&
    Boolean(emailParts[0]) &&
    emailParts[1] === COVAL_EMAIL_DOMAIN
  )
}
